import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ElevatedButton, Collaborators } from '@producer/ui-kit';
import { PersonIcon, PlusIcon } from '@radix-ui/react-icons';

import { ProjectOverviewHeader } from '../../../features/projects/components/project-overview-header';
import { OverviewTab } from '../components/overview-tab';
import { useCurrentProject } from '../../../hooks/use-current-project';
import { Header } from '../project.page';
import { TaskPanel } from '../../../features/tasks/components/task.panel';
import { uiStore } from '../../../core/stores/ui-store';
import { openModal } from '../../../core/modal/open-modal';
import { ProjectCollaboratorModal } from '../../../features/projects/modals/project-collaborator.modal';
import { openCreateStageModal } from '../../../features/process/open-create-stage-modal';
import { context } from '../../../app/context';
import { PrioritySelector } from '../../../features/process/components/priority-selector';

import styles from './project-root.screen.module.scss';
export const ProjectRootScreen = observer(() => {
  const project = useCurrentProject()!;
  const currentMember = context.member;

  useEffect(() => {
    uiStore.currentLocation = 'project.overview';
  }, []);

  const openCreateStage = () => openCreateStageModal(project._id);

  const openCollaboratorModal = () => {
    openModal(ProjectCollaboratorModal, {
      project,
    });
  };

  return (
    <>
      <Header>
        Overview
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <PrioritySelector
            priority={project.priority}
            onChange={(priority) => project.update({ priority })}
            withTitle
          />

          <Collaborators onClick={openCollaboratorModal} collaborators={project.collaborators} />

          {['owner', 'admin', 'creator'].includes(currentMember?.role || '') && (
            <ElevatedButton text="Invite" icon={<PersonIcon />} onClick={openCollaboratorModal} />
          )}
        </div>
      </Header>

      <div className={styles['content']}>
        <ProjectOverviewHeader project={project} />

        <div className={styles['container']}>
          <div className={styles['actions-row']}>
            <ElevatedButton
              text="Create stage"
              icon={<PlusIcon />}
              onClick={openCreateStage}
            />
          </div>

          <OverviewTab project={project} onCreateStage={openCreateStage} />

          {uiStore.isTaskPanelOpen && !!uiStore.taskPanelTargetId && (
            <TaskPanel targetId={uiStore.taskPanelTargetId} />
          )}
        </div>
      </div>
    </>
  );
});
